import React from "react"
import { Button } from "antd";
import { getIconUrl } from "../../services/asset";
import styles from "./styles/SearchBar.scss";
import handleFloating from "../../HOCs/handleFloating";

const SearchBarIconOnly = ({ isHomePage, scrollingLock, handleInputFocus }) => {
  return (
    <Button
      onClick={handleInputFocus}
      className={styles.searchIcon}
      style={isHomePage ? {
        transition: "300ms",
        visibility: scrollingLock ? "visible" : "hidden",
        opacity: scrollingLock ? 1 : 0,
        width: scrollingLock ? "32px" : 0,
      } : {}}
    >
      <img
        alt={"Traži"}
        src={getIconUrl("search-black.svg")}
      />
    </Button>
  );

}

export default handleFloating(SearchBarIconOnly)


// WEBPACK FOOTER //
// ./src/containers/HomePage/SearchBarIconOnly.tsx